import React, { useState, useEffect, useRef,useContext } from 'react';
import Context from '../../../context/Context';
import {
	Button,
	Col,
	Dropdown,
	Form,
	Input,
	Modal,
	Row,
	Spin,
	Table,
	message,
	Pagination,
} from 'antd';
import { debounce } from 'lodash';
import moment from 'moment';
import { IoSearchOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { EditOutlined,CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

import { api } from '../../../api/api';
import SuccessIcon from '../../../assets/successicon.svg';

import styles from './pendingDeactivation.module.scss';

import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

const getFacilityNamesFromCodes = (codesStr, facilities = []) => {
  if (!codesStr) return '';

  const codes = String(codesStr)
	.split(',')
	.map((c) => c.trim())
	.filter(Boolean);

  const map = new Map(
	(facilities || []).map((f) => [String(f.facility).trim(), f.facilityName])
  );

  return codes.map((code) => map.get(code) || code).join(', ');
};
const PendingDeactivation = () => {
	const userDetails = JSON.parse(localStorage.getItem('user-onboard-data'));
	const isAdmin = userDetails?.isAdmin === 'Y';
	const { SSPFacilities } = useContext(Context);
	const [visibleNric, setVisibleNric] = useState({});
	const toggleNric = (id) => {
		setVisibleNric((prev) => {
			const isNowVisible = !prev[id];

			if (isNowVisible) {
				setTimeout(() => {
					setVisibleNric((p) => ({
						...p,
						[id]: false,
					}));
				}, 10000);
			}

			return {
				...prev,
				[id]: isNowVisible,
			};
		});
	};
	const [form] = Form.useForm();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [rejectModal, setRejectModal] = useState(null);
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 10,
			showSizeChanger: true,
			showQuickJumper: true,
			total: 0,
			// showTotal: (total) => `Total ${total} items`,
		},
	});
	const [requestStatus, setRequestStatus] = useState({
		loading: false,
		success: null,
		error: null,
	});
	const showActionColumn = data.some(row => row.status !== 'A');
	const [reject, setReject] = useState({
		loading: false,
		success: null,
		error: null,
	});

	// Fetch the data from API
	const fetchUserPendingList = async () => {
		setLoading(true);
		try {
			const { current, pageSize } = tableParams.pagination;
			const response = await api.get({
				path:
					userDetails?.isAdmin === 'Y'
						? `/getAdminAllDeactivatePendingList`
						: `/getUserAllDeactivatePendingList?nhName=${userDetails?.nhName}`,
				params: { page: current, size: pageSize, searchText },
				service: 'useronboarding',
			});

			if (response.status === 200) {
				const pendinglist = response.data?.data;
				const totaldata = response.data?.pagination?.totalData;

				setData(pendinglist);

				setTableParams((prev) => ({
					...prev,
					pagination: {
						...prev.pagination,
						total: totaldata || response.data?.data?.length,
					},
				}));
			}
		} catch (error) {
			message.error('Something went wrong!');
		} finally {
			setLoading(false);
		}
	};

	const handleTableChange = (pagination) => {
		setTableParams((prev) => ({
			...prev,
			pagination,
		}));
	};

	const handleSearch = (e) => {
		if (e.target.value.length >= 3) {
			setSearchText(e.target.value);
			setTableParams((prev) => ({
				...prev,
				pagination: {
					...prev.pagination,
					current: 1,
				},
			}));
		}
	};

	useEffect(() => {
		fetchUserPendingList(); //eslint-disable-next-line
	}, [
		tableParams.pagination.current,
		tableParams.pagination.pageSize,
		searchText,
	]);

	const debouncedSearch = useRef(debounce(handleSearch, 300)).current;

	useEffect(() => {
		return () => {
			debouncedSearch.cancel();
		}; //eslint-disable-next-line
	}, []);

	const handleRequest = (values, action) => {
		const status = action === 'approve' ? 'A' : 'R';

		const formDataObject = {
			...values,
			status,
			modifiedBy: userDetails?.userId,
		};

		// Convert array values to comma-separated strings
		Object.keys(formDataObject).forEach((key) => {
			if (Array.isArray(formDataObject[key])) {
				formDataObject[key] = formDataObject[key].join(', ');
			}
		});

		setRequestStatus({ loading: true, success: null, error: null });

		api
			.post({
				path: '/makeruserdeactivation',
				service: 'useronboarding',
				formdata: [formDataObject],
			})
			.then(() => {
				setRequestStatus({
					loading: false,
					success: 'Request processed successfully!',
					error: null,
				});
				message.success('Request processed successfully!');
				fetchUserPendingList();
			})
			.catch((err) => {
				console.error('Error:', err.message || 'Something went wrong');
				setRequestStatus({
					loading: false,
					success: null,
					error: err.message || 'Request failed',
				});
				message.error('Request failed');
			});
	};

	const rejectRequest = (values) => {
		const formDataObject = {
			...rejectModal,
			status: 'R',
			modifiedBy: userDetails?.userId,
			remarks: values.remarks,
		};

		// Convert array values to comma-separated strings
		Object.keys(formDataObject).forEach((key) => {
			if (Array.isArray(formDataObject[key])) {
				formDataObject[key] = formDataObject[key].join(', ');
			}
		});

		setReject({ loading: true, success: null, error: null });

		api
			.post({
				path: '/makeruserdeactivation',
				service: 'useronboarding',
				formdata: [formDataObject],
			})
			.then(() => {
				setReject({
					loading: false,
					success: 'Rejected successfully!',
					error: null,
				});
				message.success('Rejected successfully!');
				fetchUserPendingList();
			})
			.catch((err) => {
				console.error('Error:', err.message || 'Something went wrong');
				setReject({
					loading: false,
					success: null,
					error: err.message || 'Request failed',
				});
				message.error('Request failed');
			})
			.finally(() => {
				setRejectModal(null);
			});
	};

	const renderRowActions = (row) => {
  const status = String(row?.status || '').trim().toUpperCase();
  
	if (status === 'A') {
	  return null;
	}

  const items = [];

  // Update Info (P & R)
  items.push({
    key: 'update',
    label: (
      <Link
        to={
          isAdmin
            ? `/admin/deactivate-user/deactivate?id=${row.id}`
            : `/deactivate-user/deactivate?id=${row.id}`
        }
      >
        <div className={styles.dropdownItem}>
          <InfoCircleOutlined className={styles.infoIcon} /> 
          <span> Update Info</span>
        </div>
      </Link>
    ),
  });

  // Admin + Pending only
  if (isAdmin && status === 'P') {
    items.push(
      {
        key: 'approve',
        label: (
          <div
            className={styles.dropdownItem}
            onClick={() => handleRequest(row, 'approve')}
          >
            <CheckCircleOutlined className={styles.approveIcon} />
            <span>Approve</span>
          </div>
        ),
      },
      {
        key: 'reject',
        label: (
          <div
            className={styles.dropdownItem}
            onClick={() => setRejectModal(row)}
          >
            <CloseCircleOutlined className={styles.rejectIcon} />
            <span>Reject</span>
          </div>
        ),
      }
    );
  }

		return (
			<div className={styles.actionTrigger}>
				<Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
					<EditOutlined />
				</Dropdown>
			</div>
		);
};


	const getStatusTag = (status) => {
	switch (status) {
		case 'A':
			return <span className={styles.badgeApproved}>Approved</span>;
		case 'R':
			return <span className={styles.badgeRejected}>Rejected</span>;
		case 'P':
			return <span className={styles.badgePending}>Pending</span>;
		case 'F':
			return <span className={styles.badgeFailed}>Failed</span>; 
		default:
			return <span className={styles.badgeUnknown}>Unknown</span>;
	}
};


	// Define the columns for the AntD table
	const columns = [
  { title: 'Status', dataIndex: 'status', key: 'status', width: 110, render: getStatusTag },

  { title: 'Date of Deactivation', dataIndex: 'deactivationDate', minWidth: 160,render: (v) => v && moment(v).format('DD-MMM-YYYY'),},
  { title: 'ECCareSuite User ID', dataIndex: 'deactivateUserName', minWidth: 180 },

  { title: 'Full Name', dataIndex: 'fullName', minWidth: 260 },
  {
	title: 'Permitted Facilities',
	dataIndex: 'nhAdminFacilities',
	key: 'nhAdminFacilities',
	render: (value) => {
		const text = getFacilityNamesFromCodes(value, SSPFacilities?.data || []);
		if (!text) return '-';

		const items = text.split(',').map(s => s.trim()).filter(Boolean);

		return (
			<div>
				{items.map((item, idx) => (
					<div key={`${item}-${idx}`}>{item}</div>
				))}
			</div>
		);
	},minWidth: 260
},
  { title: 'Submitted By', dataIndex: 'createdBy', minWidth: 160 },
  { title: 'Submitted Date', dataIndex: 'createdDate', minWidth: 160, render: (v) => v && moment(v).format('DD-MMM-YYYY'),},

  { title: 'Requestor Designation', dataIndex: 'requestorDesignation', minWidth: 240 },
  {
		  title: 'NRIC / FIN',
		  dataIndex: 'nric',
		  minWidth: 200,
		  render: (value, record) => {
			if (!value) return '-';
		
			const isVisible = visibleNric[record.id];
		
			const masked = value.replace(/.(?=.{4})/g, '*');

			  return (
				  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					  <span>{isVisible ? value : masked}</span>

					  {isVisible ? (
						  <EyeInvisibleOutlined
							  className={styles.nricEyeIcon}
							  onClick={() => toggleNric(record.id)}
						  />
					  ) : (
						  <EyeOutlined
							  className={styles.nricEyeIcon}
							  onClick={() => toggleNric(record.id)}
						  />
					  )}
				  </div>
			  );
		  },
		},
  { title: 'Email', dataIndex: 'email', minWidth: 320 },
  { title: 'Mobile Number', dataIndex: 'mobileNumber', minWidth: 180 },

  { title: "Supervisor/Manager's Name", dataIndex: 'supervisorName', minWidth: 260 },

  { title: 'Revoke Access to Clinical Facility', dataIndex: 'clinicalFacilityCodeDesc', 
	render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},minWidth: 300 },
  { title: 'Revoke Access to Finance Facility Code', dataIndex: 'financeFacilityCode',render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},
	 minWidth: 300 },
  { title: 'Revoke Access to HR Facility Code', dataIndex: 'hrFacilityCode', render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},minWidth: 300 },

  { title: 'Remarks', dataIndex: 'remarks', minWidth: 320 },
  { title: 'Confirmation Email Recipient(s)', dataIndex: 'completionEmailList', minWidth: 380 },
	isAdmin && {
	title: 'Approved By',
	dataIndex: 'modifiedBy',
	key: 'modifiedBy',
	onHeaderCell: () => ({ style: { minWidth: 300 } }),
	onCell: () => ({ style: { minWidth: 300 } }),
  },
  isAdmin && {
	title: 'Approved Date',
	dataIndex: 'modifiedDate',
	key: 'modifiedDate',
	onHeaderCell: () => ({ style: { minWidth: 300 } }),
	onCell: () => ({ style: { minWidth: 300 } }),
	render: (value) => value && moment(value).format('DD-MMM-YYYY'),
  },
  showActionColumn && {
    title: 'Action',
    key: 'action',
    fixed: 'right',
    width: 100,
    onCell: (record) => ({
        // Apply the hidden class to the TD
        className: record.status === 'A' ? styles.hiddenActionCell : '',
    }),
    render: (_, row) => {
        if (row.status === 'A') return null;
        return renderRowActions(row);
    },
},
].filter(Boolean);

	const modalStyles = {
		header: {
			borderBottom: `1px solid #E0E1E2`,
			paddingBottom: 5,
		},
	};

	return (
		<div className={styles['wrapper']}>
			<div className={styles['top-section']}>
				<div className={styles['top-section-left']}>
					<div className={styles['left']}>
						<p className={styles['title']}>All Pending Deactivation</p>
						<div className={styles['totals']}>
							<img
								className={styles['success-icons']}
								src={SuccessIcon}
								alt="Success Icon"
							/>
							<p className={styles['totals']}>
								Total Insights : {tableParams.pagination.total}
							</p>
						</div>
					</div>
					<div className={styles['right']}>
						<Input
							prefix={<IoSearchOutline />}
							className={styles['search-input']}
							placeholder="Search by full name"
							onPressEnter={handleSearch}
							onChange={debouncedSearch}
							allowClear
						/>
					</div>
				</div>
							
			<div className={styles.rejectedNote}>
				Please note: <b>Rejected</b> records will be deleted after <b>1 week</b> if they are not resubmitted.
			</div>
				{requestStatus.loading && (
					<div className={styles['saving-request']}>
						<Spin />
						<b>Saving Request</b>
					</div>
				)}
			</div>

			{/* FIXED horizontal + vertical scroll */}
			<div className={styles.horizontalFixed}>
			<div className={styles.verticalScroll}>
				<Table
					className={styles.table}
					rowKey={(record) => record.id}
					dataSource={data}
					columns={columns}
					loading={loading}
					pagination={false}
					tableLayout="auto"
					locale={{
						emptyText: (
						<div style={{ padding: '40px 0', textAlign: 'center' }}>
							No records found
						</div>
						),
					}}
					onChange={handleTableChange}
					rowClassName={(_, index) =>
						index % 2 === 0 ? styles.evenRow : styles.oddRow
					}
					scroll={{
						x: 'max-content',
						y: 450,
					}}
					/>

			</div>
			</div>

			{/* FIXED pagination */}
			<div className={styles.paginationWrapper}>
			<Pagination
				current={tableParams.pagination.current}
				pageSize={tableParams.pagination.pageSize}
				total={tableParams.pagination.total}
				showSizeChanger
				showQuickJumper
				hideOnSinglePage
				onChange={(page, pageSize) =>
				handleTableChange({ current: page, pageSize })
				}
			/>
			</div>

			{!!rejectModal && (
				<Modal
					title={<p>Reject user creation</p>}
					open={rejectModal}
					onCancel={() => {
						setRejectModal(null);
						form.resetFields();
					}}
					destroyOnClose
					centered
					footer={false}
					styles={modalStyles}
					width={500}
				>
					<Form
						id="user-reject-form"
						name="user-reject-form"
						form={form}
						labelCol={{ span: 24 }}
						onFinish={rejectRequest}
						disabled={reject.loading}
						validateTrigger={['onBlur', 'onChange']}
						initialValues={{ remarks: rejectModal?.remarks }}
					>
						<Row gutter={20}>
							{/* Remarks */}
							<Col xs={24}>
								<Form.Item
									label="Remarks"
									name="remarks"
									rules={[
										{
											required: true,
											message: 'Please enter remarks!',
										},
										({ getFieldValue }) => ({
											validator(_, value) {
												if (!value || value !== rejectModal?.remarks) {
													return Promise.resolve();
												}
												return Promise.reject(
													new Error(
														'Remarks must be different from the previous one!'
													)
												);
											},
										}),
									]}
								>
									<Input.TextArea
										placeholder="Please enter Remarks!"
										autoSize={{
											minRows: 5,
											maxRows: 5,
										}}
									/>
								</Form.Item>
							</Col>
							<Col xs={24}>
								<Form.Item style={{ marginBottom: 0 }}>
									<Button
										loading={reject.loading}
										type="primary"
										htmlType="submit"
										block
									>
										Reject User
									</Button>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			)}
		</div>
	);
};

export default PendingDeactivation;
